import { CommonHelper } from '../../helpers/CommonHelper';

class ParametersSerializer {
  static deSerialize(data) {
    const parameterObject = {};
    const parameterArray = data[0] || [];
    parameterArray.forEach((item) => {
      const key = item.ParNombre;
      const value = item.ParTexto ? item.ParTexto : item.ParValor;
      parameterObject[key] = value;
    });
    const countryDocumentsArray = (data[1] || []).map(countryData => (
      {
        id: countryData.PaiCodigo,
        country: String(countryData.PaiNombre).trim(),
        documents: countryData.PaisDelDocumento.map(documentData => (
          {
            id: documentData.PDDId,
            name: documentData.PDDNombre,
          }
        )),
      }
    )).sort((a, b) => (a.country < b.country ? -1 : 1));

    const addressExtraInfoFields = (data[2] || []).map(extraInfoData => ({
      id: extraInfoData.ID,
      value: extraInfoData.Nombre,
    })).sort((a, b) => (a.value < b.value ? -1 : 1));

    let intraSearchFilters = null;
    if (data[3]) {
      intraSearchFilters = data[3].map(filter => ({
        label: filter.Key,
        value: filter.Value,
      }));
    }

    const paymentMethods = CommonHelper
      .moveByIdToFirstPosition((data[4] || []).map(paymentMethod => ({
        id: paymentMethod.IDFormaPago,
        description: paymentMethod.ComoPaga,
        detail: paymentMethod.Detalle,
        typeReference: paymentMethod.IDReferencias,
        references: paymentMethod.Referencias ? paymentMethod.Referencias.map(item => ({
          id: item.ID,
          name: item.Descripcion,
          code: item.Texto,
        })) : [],
      })), 4);

    const contactReasons = (data[5] || []).map(reason => ({
      id: reason.Key,
      name: reason.Value,
    }));

    const installationDate = new Date(data[6].PrimerDia);

    const disableSale = data[7] && { status: data[7].Estado, message: data[7].Mensaje };

    return {
      addressExtraInfoFields,
      countryDocuments: countryDocumentsArray,
      minimumFinancingPercentage: parameterObject.Factuacion_PorcInicialEntrega,
      intraSearchFilters,
      paymentMethods,
      contactReasons,
      installationDate,
      disableSale,
    };
  }
}

export { ParametersSerializer };



// WEBPACK FOOTER //
// ./src/networking/serializers/ParametersSerializer.js